/* eslint-disable react/jsx-no-bind, no-unused-vars, import/first, react/sort-comp, arrow-parens, no-var, no-restricted-syntax, eqeqeq, comma-dangle, arrow-body-style, no-param-reassign, consistent-return, no-loop-func */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import ReactResizeDetector from 'react-resize-detector';
import { uniqueId } from 'lodash';
import { Line as ProgressBar } from 'rc-progress';
import _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { makeSelectStepSupportingDocuments, makeSelectStepSupportingDocumentsErrors } from './selectors';
import reducer from './reducer';

import { Button } from '../components/Button';
import WizardNavigationButtons from '../components/WizardNavigationButtons';
import Section from '../components/Section';
import ControlContainer from '../components/ControlContainer';
import OptionsContainer from '../components/OptionsContainer';
import FlexBox from '../../../components/FlexBox';
import {
  removeFile,
  resetFormData,
  uploadFile,
  uploadRequireDocFile,
  runRequiredDocValidation,
  cancelRequiredDocValidation,
  nextSlide,
  handleFormDataChange,
} from './actions';
import { REQUIRED_DOCUMENT_DISPLAY_CODE } from 'containers/FastCover/constants';
import { Table, TH, TR, TD } from '../../../components/Table';
import Icon from '../../../components/Icon';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import messages from './messages';
import { makeSelectJSONVersion, makeSelectInitClaimTypeList, makeSelectShowRequiredDocument, makeSelectShowZurichUHC, makeSelectPolicyTypeCode, makeSelectPolicyPlanIds, makeSelectFormHasChanges } from '../../App/selectors';
import { AttachSupportingDocuments } from './components/AttachSupportingDocuments';
import { UploadSupportingDocuments } from './components/UploadSupportingDocuments';
import { ShowPBEValidationMesssage } from './components/ShowPBEValidationMesssage';
import { ShowPBValidationMesssage } from './components/ShowPBValidationMesssage';
import { ShowSupportingDocuments } from './components/ShowSupportingDocuments';
import { saveFormData } from '../actions';
import { setFormHasChanges } from '../../App/actions';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton';
import ModalError from './components/ModalError';
import { makeSelectStepWhatHappened } from '../StepWhatHappened/selectors';
import { makeSelectStepTripCancellationAndTripInterruption } from '../StepTripCancellationAndTripInterruption/selectors';
import { makeSelectStepOther } from '../StepOther/selectors';
import { makeSelectTripCancellationCFStep } from '../Trawick.CFTripCan.TripCancellationStep/selectors';
import { makeSelectMedicalExpenseCFStep } from '../Trawick.CFTripCan.MedicalExpense/selectors';
import { makeSelectStepTravelDelay } from '../StepTravelDelay/selectors';
import { makeSelectTripDelayStep } from '../Trawick.NationWide.TripDelayStep/selectors';
import { makeSelectMedicalAndEvacuationSCTIStep } from '../Trawick.SCTI.MedicalAndEvacuation/selectors';
import { makeSelectBaggageAndPersonalItemsSCTIStep } from '../Trawick.SCTI.BaggageAndPersonalItems/selectors';
import { makeSelectChangesToYourJourneySCTIStep } from '../Trawick.SCTI.ChangesToYourJourney/selectors';
import { makeSelectChangesToYourJourneyStep } from '../Trawick.ChangesToYourJourney/selectors';
import { makeSelectStepBaggageAndPersonalItems } from '../StepBaggageAndPersonalItems/selectors';
import { makeSelectStepBaggageAndPersonalItemsStarr } from '../Trawick.Starr.StepBaggageAndPersonalItems/selectors';
import { makeSelectStepOtherStarr } from '../Trawick.Starr.StepOther/selectors';
import { makeSelectCollisionDamageStarrStep } from '../Trawick.Starr.StepCollisionDamage/selectors';
import { makeSelectCollisionDamageStep } from '../Trawick.NationWide.CollisionDamageStep/selectors';
import { makeSelectCashBankCardsTravelDocumentsAndPassportsStep } from '../Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/selectors';
import StepCancellationAdditionalShared from '../StepCancellationAdditional/components/StepCancellationAdditionalShared';
import StepPersonalItemsShared from '../StepPersonalItems/components/StepPersonalItemsShared';
import StepOverseasMedicalShared from '../StepOverseasMedical/components/StepOverseasMedicalShared';
import StepRentalVehicleShared from '../StepRentalVehicle/StepRentalVehicleShared';
import StepOtherShared from '../StepOther/components/StepOtherShared';
import StepOtherSharedForAD from '../StepOther/components/StepOtherSharedForAD';
import StepOtherSharedForBurialExpenses from '../StepOther/components/StepOtherSharedForBurialExpenses';
import StepOtherSharedForRepatriationExpenses from '../StepOther/components/StepOtherSharedForRepatriationExpenses';
import StepTripCancellationAndTripInterruptionSharedTravelDelay from '../StepTripCancellationAndTripInterruption/components/StepTripCancellationAndTripInterruptionSharedTravelDelay';
import StepBaggageAndPersonalItemsShared from '../StepBaggageAndPersonalItems/components/StepBaggageAndPersonalItemsShared';
import StepMedicalExpensesShared from '../StepMedicalExpenses/components/StepMedicalExpensesShared';
import MedicalExpenseStepShared from '../Trawick.NationWide.MedicalExpenseStep/components/MedicalExpenseStepShared';
import TripCancellationStepShared from '../Trawick.NationWide.TripCancellationStep/components/TripCancellationStepShared';
import TripInterruptionStepShared from '../Trawick.NationWide.TripInterruptionStep/components/TripInterruptionStepShared';
import TripDelayStepShared from '../Trawick.NationWide.TripDelayStep/components/TripDelayStepShared';
import MissedConnectionStepShared from '../Trawick.NationWide.MissedConnectionStep/components/MissedConnectionStepShared';
import PropertyDamageStepShared from '../Trawick.NationWide.PropertyDamageStep/components/PropertyDamageStepShared';
import CollisionDamageStepShared from '../Trawick.NationWide.CollisionDamageStep/components/CollisionDamageStepShared';
import PetMedicalStepShared from '../Trawick.NationWide.PetMedicalStep/components/PetMedicalStepShared';
import AccidentalDeathAndDismembermentStepShared from '../Trawick.NationWide.AccidentalDeathAndDismembermentStep/components/AccidentalDeathAndDismembermentStepShared';
import ItineraryChangeStepShared from '../Trawick.CFTripCan.ItineraryChange/components/ItineraryChangeStepShared';
import MedicalExpenseCFStepShared from '../Trawick.CFTripCan.MedicalExpense/components/MedicalExpenseCFStepShared';
import MedicalExpenseZurichStepShared from '../Trawick.Zurich.MedicalExpense/components/MedicalExpenseZurichStepShared';
import BaggagePersonalEffectsShared from '../Trawick.CFTripCan.BaggagePersonalEffects/components/BaggagePersonalEffectsShared';
import TripCancellationCFStepShared from '../Trawick.CFTripCan.TripCancellationStep/components/TripCancellationCFStepShared';
import TripDelayCFStepShared from '../Trawick.CFTripCan.TripCancellationStep/components/TripDelayCFStepShared';
import TripInterruptionCFStepShared from '../Trawick.CFTripCan.TripCancellationStep/components/TripInterruptionCFStepShared';
import JobLossHardshipStepShared from '../Trawick.DuesProtect.JobLossHardshipStep/components/JobLossHardshipStepShared';
import DisasterAssistanceHardshipStepShared from '../Trawick.DuesProtect.DisasterAssistanceHardshipStep/components/DisasterAssistanceHardshipStepShared';
import CriticalIllnessStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/CriticalIllnessStepShared';
import DeathStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/DeathStepShared';
import DisabilityStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/DisabilityStepShared';
import DismembermentStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/DismembermentStepShared';
import LeaveOfAbsenceStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/LeaveOfAbsenceStepShared';
import StepMedicalAndEvacuationShared from '../Trawick.SCTI.MedicalAndEvacuation/components/StepMedicalAndEvacuationShared';
import StepChangesToYourJourneyShared from '../Trawick.SCTI.ChangesToYourJourney/components/StepChangesToYourJourneyShared';
import StepBaggageAndPersonalItemsSCTIShared from '../Trawick.SCTI.BaggageAndPersonalItems/components/StepBaggageAndPersonalItemsShared';
import StepPersonalAccidentSCTIShared from '../Trawick.SCTI.PersonalAccident/components/StepPersonalAccidentShared';
import StepRentalVehicleExcessSCTIShared from '../Trawick.SCTI.RentalVehicleExcess/components/StepRentalVehicleExcessShared';
import StepCashBankCardsTravelDocumentsAndPassportsShared from '../Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/components/StepCashBankCardsTravelDocumentsAndPassportsShared';
import {
  stepCancellationAdditionalExpenseLookup,
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepAccidentalDeathAndDismembermentLookup,
  stepMedicalExpenseCFLookup,
  stepTripCancellationCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
  stepTripCancellationTugoLookup,
  stepTripCancellationTravellerTugoLookup,
  stepStandardVTCMedicalBenefitsTugoLookup,
  stepTravellerMedicalBenefitsTugoLookup,
  stepOptimumMedicalBenefitsTugoLookup,
} from '../dataMapper/claimCodeMapper';
import stepSupportingDocumentsDataMapper from '../dataMapper/stepSupportingDocumentsDataMapper';
import P from '../../../components/P';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation';
import { makeSelectCurrentStep } from '../../Wizard/selectors';

import { makeSelectMedicalExpensesTugoStep } from '../Tugo.MedicalExpenses/selectors';
import { makeSelectStepOtherTugo } from '../Tugo.StepOther/selectors';
import { makeSelectStepMedicalExpenses } from '../StepMedicalExpenses/selectors';
// import { makeSelectMedicalExpenseCFStep } from '../Trawick.CFTripCan.MedicalExpense/selectors';
import { makeSelectBaseVictorsMedicalTugo } from '../Tugo.BaseVictorsMedical/selectors';
import { makeSelectStudentMedicalBenefitsTugo } from '../Tugo.StudentMedicalBenefits/selectors';
import { makeSelectStepTripCancellationTugo } from '../Tugo.TripCancellation/selectors';
import { makeSelectStepTripCancellationTravellerTugo } from '../Tugo.TripCancellationTraveller/selectors';
import { makeSelectTripInterruptionTugo } from '../Tugo.TripInterruption/selectors';
import { makeSelectStandardVTCMedicalBenefitsTugo } from '../Tugo.StandardVTCMedicalBenefits/selectors';
import { makeSelectTravellerMedicalBenefitsTugo } from '../Tugo.TravellerMedicalBenefits/selectors';
import { makeSelectOptimumMedicalBenefitsTugo } from '../Tugo.OptimumMedicalBenefits/selectors';
import { makeSelectADAndDBenefitsTugo } from '../Tugo.ADAndDBenefits/selectors';
import { makeSelectStepOtherInsuranceCoverageTugo } from '../Tugo.StepOtherInsuranceCoverage/selectors';
import { makeSelectBaggageAndPersonalItemsTravellerTugo } from '../Tugo.BaggageAndPersonalItemsTraveller/selectors';
import { makeSelectRentalCarProtectionTravellerTugo } from '../Tugo.RentalCarProtectionTraveller/selectors';
import { appConfig } from '../../../configureApp';
// import stepMedicalExpenseCFDataMapper from '../dataMapper/stepMedicalExpenseCFDataMapper';
// import stepBaggageAndPersonalItemsStarrDataMapper from '../dataMapper/stepBaggageAndPersonalItemsStarrDataMapper';
import { map as mapToClaimData } from '../dataMapper/apiContractMapper';
import { formatClaimTypeDocumentsHeader } from '../utils/claimTypeDescriptionLocalization';

export class StepSupportingDocuments extends React.Component {
  constructor(props) {
    super(props);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.allowValidateDocuments = {};

    this.state = {
      invalidFileName: false,
      isLongFileName: false,
      listDocuments: [],
    };

    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.checkFileNameLength = this.checkFileNameLength.bind(this);
    this.onAttachDocumentChange = this.onAttachDocumentChange.bind(this);
    this.onAttachRequiredDocumentChange = this.onAttachRequiredDocumentChange.bind(this);
    this.onRunValidation = this.onRunValidation.bind(this);
    this.onCancelValidation = this.onCancelValidation.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;

    const snapshot =
      nextProps.form && nextProps.form.submittedDocumentsSnapshot;

    // Use snapshot when it exists AND has at least one document entry.
    // An empty snapshot.documents array can occur when captureDocumentsSnapshot ran
    // before listDocuments was populated (e.g. rapid navigation); fall back to
    // mapDocumentItems in that case so the UI does not appear blank.
    const shouldUseSnapshot =
      (nextProps.submitted || nextProps.isSummary) &&
      snapshot &&
      Array.isArray(snapshot.documents) &&
      snapshot.documents.length > 0;

    // When rendered inside SummaryScreen (isSummary) without a valid snapshot, honour the
    // stepWhatHappenedData prop that SummaryScreen has already filtered by policyPlanIds.
    // Redux's default mergeProps ({...ownProps, ...stateProps}) means stateProps wins, so we
    // read the ownProp version via the dedicated summaryStepWhatHappenedData channel.
    const effectiveNextProps =
      !shouldUseSnapshot && nextProps.isSummary && nextProps.summaryStepWhatHappenedData
        ? { ...nextProps, stepWhatHappenedData: nextProps.summaryStepWhatHappenedData }
        : nextProps;

    const listDocuments = shouldUseSnapshot
      ? snapshot.documents
      : this.mapDocumentItems(effectiveNextProps);

    if (listDocuments.length === 0 && !nextProps.isSummary) {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', false);
      this.props.onFormDataChange('form.warningMissingRequiredDocument', '');
    }

    this.setState({ listDocuments });

    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }
    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  componentWillUpdate() {
    if (this.props.adjust) {
      // this is a workaround to ensure we refresh the UI
      // to render the list of attachments.
      this.props.adjust();
    }
  }
  componentDidUpdate(prevProps) {
    // Check if attachDocuments has changed after upload
    if (prevProps.form.attachDocuments !== this.props.form.attachDocuments) {
      this.validateRequiredDocuments();

      // Auto-trigger validation for newly uploaded files
      this.autoTriggerValidation(this.props.form.attachDocuments, prevProps.form.attachDocuments);
    }
  }

  onResize() {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  }

  autoTriggerValidation = (currentAttachments, prevAttachments) => {
    // Find newly uploaded files
    const newAttachments = currentAttachments.filter(currentAttachment =>
      !prevAttachments.some(prevAttachment => prevAttachment.id === currentAttachment.id)
    );

    // Logic: If a file is uploaded against the same row (requiredDocumentId),
    // CANCEL the current validation and restart it with the new data.
    // If files are for different rows, validations run in parallel without cancelling each other.
    var requiredDocumentIds = newAttachments.map(att => att.requiredDocumentId);
    requiredDocumentIds = [...new Set(requiredDocumentIds)]; // Unique IDs

    const { listDocuments } = this.state;
    requiredDocumentIds.forEach(requiredDocumentId => {
      // Find the document details to check if validation is required
      const document = this.findDocumentById(requiredDocumentId, listDocuments);
      if (document && document.runDocumentValidation === true) {
        // Cancel any existing validation for this requiredDocumentId before starting new one
        this.onCancelValidation(requiredDocumentId, document.claimTypeId);
        // Start new validation
        this.onRunValidation([], requiredDocumentId, document.claimTypeId);
      }
    });
  };

  findDocumentById = (requiredDocumentId, listDocuments) => {
    for (const item of listDocuments) {
      const document = (item.requiredDocuments || []).find(doc =>
        doc.claimRequiredDocumentId == requiredDocumentId,
      );
      if (document && this.allowValidateDocuments[item.claimTypeId] == true) {
        return {
          ...document,
          claimTypeId: item.claimTypeId
        };
      }
    }
    return null;
  };

  onAttachDocumentChange(benefitCode, files, documentDescription) {
    const { onFileUpload } = this.props;
    const file = files ? files[0] : {};
    if (this.checkFileNameLength(file)) {
      this.setState({ isLongFileName: true }, () => {
        this.showModal();
      });
    } else if (this.checkFileExist(file)) {
      this.setState({ isLongFileName: false }, () => {
        this.showModal();
      });
    } else {
      onFileUpload(files, benefitCode, documentDescription);
      this.props.setFormHasChanges(true);
    }
  }

  onAttachRequiredDocumentChange(benefitCode, requiredDocumentId, claimTypeId, claimExpenseGuid, displayCode, files) {
    const { onRequireDocFileUpload } = this.props;
    const file = files ? files[0] : {};
    const uploadRequest = {
      benefitCode,
      requiredDocumentId,
      claimTypeId,
      claimExpenseGuid,
      displayCode,
    };
    if (this.checkFileNameLength(file)) {
      this.setState({ isLongFileName: true }, () => {
        this.showModal();
      });
    } else if (this.checkFileExist(file)) {
      this.setState({ isLongFileName: false }, () => {
        this.showModal();
      });
    } else {
      onRequireDocFileUpload(files, uploadRequest);
      this.props.setFormHasChanges(true);
    }
  }

  handleFileRemove = (file) => {
    this.props.onFileRemove(file);
    this.props.setFormHasChanges(true);
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  };

  checkFormError() {
    const {
      attachDocuments,
      warningMissingRequiredDocument,
      validationMessages,
    } = this.props.form;
    const { listDocuments } = this.state;
    const { jsonVersion } = this.props;
    const versionFNOLRefactoring = jsonVersion > 11;
    const versionShowInvalidRequiredDoc = jsonVersion > 15;
    const requiredDocumentsList = listDocuments
      .map((item) => {
        return (item.requiredDocuments || []).filter((doc) => {
          if (doc.mandatory === true) {
            doc.claimTypeId = item.claimTypeId;
            return true;
          }
          return false;
        });
      })
      .flat();

    // Filter missing documents
    const missingDocuments = requiredDocumentsList.filter((doc) =>
      !attachDocuments.some((up) => up.requiredDocumentId === doc.claimRequiredDocumentId)
    );
    const to = requiredDocumentsList.filter((doc) =>
      !validationMessages.some((up) => up.requiredDocumentId === doc.claimRequiredDocumentId)
    );

    const validationRequiredDocs = requiredDocumentsList.filter(doc => doc.runDocumentValidation === true && this.allowValidateDocuments[doc.claimTypeId] == true);

    // Check if length mismatch or if any validation message has success = false or null
    const lengthMismatch = validationMessages.length !== validationRequiredDocs.length;
    const hasFailedOrPendingValidation = validationMessages.some(msg => msg.Success !== true);
    const isValidRequiredDocument = !lengthMismatch && !hasFailedOrPendingValidation;

    const requiresGHIPDoc = this.props.stepOtherInsuranceCoverageTugoData &&
      this.props.stepOtherInsuranceCoverageTugoData.hasProvincialHealthCoverage === 'true';
    const hasGHIPDoc = !requiresGHIPDoc ||
      attachDocuments.some((up) => up.benefitCode === 'PROVINCIAL_HEALTH_COVERAGE');
    const isValidetionrRquiredDocument = missingDocuments.length === 0 && hasGHIPDoc;
    if (!versionFNOLRefactoring || (isValidetionrRquiredDocument && isValidRequiredDocument && to)) {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', false);
      this.props.onFormDataChange('form.warningMissingRequiredDocument', '');
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', false);
    } else {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', !isValidetionrRquiredDocument);
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', versionShowInvalidRequiredDoc ? !isValidRequiredDocument : false);
    }

    const valid = this.validatorGroup.checkValidation() && (warningMissingRequiredDocument === '' || !versionFNOLRefactoring);
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.handleFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  validateRequiredDocuments = () => {
    const {
      attachDocuments,
      warningMissingRequiredDocument,
      validationMessages,
    } = this.props.form;
    const { listDocuments } = this.state;
    const { jsonVersion, submitted } = this.props;
    const versionFNOLRefactoring = jsonVersion > 11;

    if (submitted) {
      this.props.next();
      return;
    }

    const versionShowInvalidRequiredDoc = jsonVersion > 15;
    const requiredDocumentsList = listDocuments
      .map((item) => {
        return (item.requiredDocuments || []).filter((doc) => {
          if (doc.mandatory === true) {
            doc.claimTypeId = item.claimTypeId;
            return true;
          }
          return false;
        });
      })
      .flat();
    // Filter missing documents
    const missingDocuments = requiredDocumentsList.filter((doc) =>
      !attachDocuments.some((up) => up.requiredDocumentId === doc.claimRequiredDocumentId)
    );

    const validationRequiredDocs = requiredDocumentsList.filter(doc => doc.runDocumentValidation === true && this.allowValidateDocuments[doc.claimTypeId] == true);

    // Check if length mismatch or if any validation message has success = false or null
    const lengthMismatch = validationMessages.length !== validationRequiredDocs.length;
    const hasFailedOrPendingValidation = validationMessages.some(msg => msg.Success !== true);
    let isValidRequiredDocument = !lengthMismatch && !hasFailedOrPendingValidation;

    const requiresGHIPDoc = this.props.stepOtherInsuranceCoverageTugoData &&
      this.props.stepOtherInsuranceCoverageTugoData.hasProvincialHealthCoverage === 'true';
    const hasGHIPDoc = !requiresGHIPDoc ||
      attachDocuments.some((up) => up.benefitCode === 'PROVINCIAL_HEALTH_COVERAGE');
    let isValidetionrRquiredDocument = missingDocuments.length === 0 && hasGHIPDoc;
    if (!versionFNOLRefactoring || (isValidetionrRquiredDocument && isValidRequiredDocument)) {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', false);
      this.props.onFormDataChange('form.warningMissingRequiredDocument', '');
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', false);
    } else {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', !isValidetionrRquiredDocument);
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', versionShowInvalidRequiredDoc ? !isValidRequiredDocument : false);
    }

    if (warningMissingRequiredDocument === 'true') {
      isValidetionrRquiredDocument = true;
      isValidRequiredDocument = true;
    }
    return isValidetionrRquiredDocument && isValidRequiredDocument;
  };

  captureDocumentsSnapshot = () => {
    const { listDocuments } = this.state;
    const { attachDocuments } = this.props.form;

    // Capture full document structure including mandatory flags and all metadata
    const documentsSnapshot = listDocuments.map((item) => ({
      claimTypeId: item.claimTypeId,
      claimCode: item.claimCode,
      description: item.description,
      requiredDocuments: (item.requiredDocuments || []).map((doc) => ({
        claimRequiredDocumentId: doc.claimRequiredDocumentId,
        requiredDocumentDescription: doc.requiredDocumentDescription,
        mandatory: doc.mandatory,
        toolTipDescription: doc.toolTipDescription,
        runDocumentValidation: doc.runDocumentValidation,
        Success: doc.Success,
        Message: doc.Message,
      })),
    }));

    // Capture current attachments
    const attachmentsSnapshot = (attachDocuments || []).map((attachment) => ({
      id: attachment.id,
      name: attachment.name,
      benefitCode: attachment.benefitCode,
      requiredDocumentId: attachment.requiredDocumentId,
      groupName: attachment.groupName,
      success: attachment.success,
      message: attachment.message,
    }));

    // Store the complete snapshot
    const snapshot = {
      documents: documentsSnapshot,
      attachments: attachmentsSnapshot,
      capturedAt: new Date().toISOString(),
    };

    this.props.onFormDataChange('form.submittedDocumentsSnapshot', snapshot);
  };

  handleNext = () => {
    // Capture snapshot before moving to next step (which is declaration step)

    const {
      warningMissingRequiredDocument,
    } = this.props.form;
    const { submitted, jsonVersion, showRequiredDocument } = this.props;
    const versionFNOLRefactoring = jsonVersion > 11;

    if (submitted) {
      this.props.next();
      return;
    }

    // When showRequiredDocument is false, skip validation and navigate directly
    if (!showRequiredDocument) {
      this.handleFormDataSave();
      this.props.next();
      return;
    }

    const isRequiredDocumentValid = this.validateRequiredDocuments();

    const valid = this.validatorGroup.checkValidation() && (warningMissingRequiredDocument === '' || !versionFNOLRefactoring);
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    if (isRequiredDocumentValid || !versionFNOLRefactoring) {
      this.captureDocumentsSnapshot();
      this.handleFormDataSave();
      this.props.next();
    }
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showModal() {
    this.setState({ invalidFileName: true });
  }

  hideModal() {
    this.setState({ invalidFileName: false });
  }

  checkFileNameLength(file) {
    if (file.name && file.name.length > 50) {
      return true;
    }
    return false;
  }

  checkFileExist = (file) => {
    if (this.props.form.attachDocuments.length) {
      return this.props.form.attachDocuments.filter((f) => f.name === file.name).length > 0;
    }
    return false;
  };

  mapQuestionItem(claimType, description) {
    return stepSupportingDocumentsDataMapper.mapQuestionItem(claimType, description);
  }

  onRunValidation(attachmentIds, requiredDocumentId, claimTypeId) {
    const { onRunRequiredDocValidation } = this.props;
    onRunRequiredDocValidation(attachmentIds, requiredDocumentId, claimTypeId);
  }

  mapDocumentItems(props = this.props) {
    return stepSupportingDocumentsDataMapper.mapDocumentItems({
      claimTypesInit: props.claimTypesInit,
      policyTypeCode: props.policyTypeCode,
      policyPlanIds: props.policyPlanIds,
      selectedBenefits: props.stepWhatHappenedData.selectedBenefits,
      stepTripCancellationAndTripInterruptionData: props.stepTripCancellationAndTripInterruptionData,
      stepOtherData: props.stepOtherData,
      stepMedicalAndEvacuationSCTIData: props.stepMedicalAndEvacuationSCTIData,
      stepBaggageAndPersonalItemsSCTIData: props.stepBaggageAndPersonalItemsSCTIData,
      stepCashBankCardsTravelDocumentsAndPassportsData: props.stepCashBankCardsTravelDocumentsAndPassportsData,
      stepChangesToYourJourneySCTIData: props.stepChangesToYourJourneySCTIData,
      stepChangesToYourJourneyData: props.stepChangesToYourJourneyData,
      stepBaggageAndPersonalItemsData: props.stepBaggageAndPersonalItemsData,
      stepBaggageAndPersonalItemsStarrData: props.stepBaggageAndPersonalItemsStarrData,
      stepMedicalExpenseCFData: props.stepMedicalExpenseCFData,
      stepOtherStarrData: props.stepOtherStarrData,
      stepCollisionDamageData: props.stepCollisionDamageData,
      stepCollisionDamageStarrData: props.stepCollisionDamageStarrData,
      stepMedicalExpensesData: props.stepMedicalExpensesData,
      stepMedicalExpensesTugoData: props.stepMedicalExpensesTugoData,
      stepOtherTugoData: props.stepOtherTugoData,
      stepBaseVictorsMedicalTugoData: props.stepBaseVictorsMedicalTugoData,
      stepStudentMedicalBenefitsTugoData: props.stepStudentMedicalBenefitsTugoData,
      stepTripCancellationTugoData: props.stepTripCancellationTugoData,
      stepTripCancellationTravellerTugoData: props.stepTripCancellationTravellerTugoData,
      stepTripInterruptionTugoData: props.stepTripInterruptionTugoData,
      stepStandardVTCMedicalBenefitsTugoData: props.stepStandardVTCMedicalBenefitsTugoData,
      stepTravellerMedicalBenefitsTugoData: props.stepTravellerMedicalBenefitsTugoData,
      stepOptimumMedicalBenefitsTugoData: props.stepOptimumMedicalBenefitsTugoData,
      stepADAndDBenefitsTugoData: props.stepADAndDBenefitsTugoData,
      stepBaggageAndPersonalItemsTravellerTugoData: props.stepBaggageAndPersonalItemsTravellerTugoData,
      stepRentalCarProtectionTravellerTugoData: props.stepRentalCarProtectionTravellerTugoData,
    });
  }

  renderUploadAreaForBenefits = (listDocuments, attachDocuments, onAttachDocumentChange, onAttachRequiredDocumentChange, onFileRemove, isReadOnly) => {
    const { intl, jsonVersion, policyTypeCode, showZurichUHC, showRequiredDocument } = this.props;
    const newVersion = jsonVersion > 10 && showRequiredDocument;
    const toArray = (value) => (!!value && typeof value.toJS === 'function' ? value.toJS() : value || []);
    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const policyTypeVisitingNZ = ['VISIT-NZ', 'VISIT-NZ-PI'];
    const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);
    const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
    const isShowSubBenefits = isInternationalStudent || isVisitingNewZealand || isWorkingOverseas;
    const { travelInterruption, tripCancellation, tripCancellationForAnyReason } = this.props.stepTripCancellationAndTripInterruptionData;
    const { travelDelay } = this.props.stepTravelDelayData;
    const { travelDelay: tripDelay } = this.props.stepTripDelayData;
    const { tripCancellation: tripCancellationCF, travelDelay: travelDelayCF, travelInterruption: travelInterruptionCF } = this.props.stepTripCancellationCFData;
    const { areYouClaimingForAccidentalDeathAndDismemberment, areYouClaimingForRepatriationExpenses, areYouClaimingForBurialExpenses, whatExpensesAreYouClaimingFor, whatAreYourExpensesRelatedTo } = this.props.stepOtherData;
    const { didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised, wasTheDeathCausedByAnInjury, whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI, whatAreYourExpensesRelatedTo: MAEWhatAreYourExpensesRelatedTo } = this.props.stepMedicalAndEvacuationSCTIData;
    const { whatHappenedToYourBaggageAndPersonalItems, whatItemsAreYouClaimingFor } = this.props.stepBaggageAndPersonalItemsSCTIData;
    const { whatItemsAreYouClaimingFor: passportItemsClaiming } = this.props.stepCashBankCardsTravelDocumentsAndPassportsData;
    const { haveYouCanceledOrChangedYourJourneyBeforeLeaving, haveYouChangedYourJourneyAfterLeaving, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition,
      wereYouChargedACancellationFeeByTheTravelAgent, wereYouDelayedWhileTravelingToASpecialEvent, wereYouDelayedWhileTravelingToASpecialEventAL,
      didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL } = this.props.stepChangesToYourJourneySCTIData;
    const {
      whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalExpensesTugo,
      isClaimRelatedToSelfInflictedYes,
      isClaimRelatedToSelfInflictedNo,
      isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt,
      isYourClaimRelatedToPsychiatricTreatment,
      isYourClaimRelatedToHIV,
      diagnosticImaging,
    } = this.props.stepMedicalExpensesTugoData || {};

    const expensesPersonalLiabilitySelected = toArray(whatExpensesAreYouClaimingFor);
    const whatAreYourExpensesRelatedToSelected = toArray(whatAreYourExpensesRelatedTo);
    const isPersonalLiabilitySelected = expensesPersonalLiabilitySelected.includes('Personal Liability');
    const isPersonalAccidentSelected = expensesPersonalLiabilitySelected.includes('Personal Accident');
    const isLossOfIncomeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Income');
    const isTotalPermanentDisablementCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Total permanent disablement');
    const isLossOfLifeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Life');

    const medicalAndEvacuationSCTISelected = toArray(whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI);
    const MAEWhatAreYourExpensesRelatedToSelected = toArray(MAEWhatAreYourExpensesRelatedTo);
    const isMedicalHospitalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Medical & Hospital Expenses');
    const isDentalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Dental Expenses');
    const isFuneralExpensesSelected = medicalAndEvacuationSCTISelected.includes('Funeral Expenses');
    const isExpensesarisingfromterrorismSelected = medicalAndEvacuationSCTISelected.includes('Expenses arising from terrorism');
    const isExtraTravelAndAccommodationSelected = MAEWhatAreYourExpensesRelatedToSelected.includes('Extra travel and accommodation');

    const baggageAndPersonalItemsSelected = toArray(whatHappenedToYourBaggageAndPersonalItems);
    const damagedItemsSelected = toArray(whatItemsAreYouClaimingFor);
    const isDaggageDelaySelected = baggageAndPersonalItemsSelected.includes('Baggage delay');
    const isEssentialMedicationSelected = damagedItemsSelected.includes('Essential medication');
    const isSpecifiedHighValueItemsSelected = damagedItemsSelected.includes('Specified high value items');
    const isBankCardsOrTravelDocumentsSelected = damagedItemsSelected.includes('Bank cards or travel documents');
    const isCashSelected = damagedItemsSelected.includes('Cash');
    const isJewelleryOrTraditionalWatchesSelected = damagedItemsSelected.includes('Jewellery or traditional watches');
    const isUnspecifiedLaptopSelected = damagedItemsSelected.includes('Laptops, tablets or cameras');
    const isOtherUnspecifiedItemsSelected = damagedItemsSelected.includes('Other unspecified items');

    const didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruptionSelected = toArray(didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption);
    const isChildCareExpensesSelected = didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruptionSelected.includes('Childcare expenses');
    const isPetBoardingFacilitySelected = didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruptionSelected.includes('Pet boarding facility');

    const cashBankCardsTravelDocumentsAndPassportsSelected = toArray(passportItemsClaiming);
    const isPassportsBankCardsOrTravelDocumentsSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Bank cards or travel documents');
    const isPassportsCashSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Cash');

    const medicalExpensesTugoSelected = toArray(whatExpensesAreYouClaimingForMedicalExpensesTugo);
    const isClaimRelatedToSelfInflictedYesChecked = isClaimRelatedToSelfInflictedYes === 'true' || isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt === 'yes';
    const isClaimRelatedToSelfInflictedNoChecked = isClaimRelatedToSelfInflictedNo === 'true';
    const isNonMRIChecked = diagnosticImaging && diagnosticImaging.includes('diagnosticNonMRI');
    const isMRIChecked = diagnosticImaging && diagnosticImaging.includes('diagnosticMRI');
    const isMaternityExpenseSelected = medicalExpensesTugoSelected.includes('Maternity Expense');
    const isOncologySelected = medicalExpensesTugoSelected.includes('Oncology');
    const isCleftLipAndPalateAssistanceSelected = medicalExpensesTugoSelected.includes('Cleft Lip and Palate Assistance');
    const isWellBabyCareSelected = medicalExpensesTugoSelected.includes('Well Baby Care');
    const isAnnualHealthExamSelected = medicalExpensesTugoSelected.includes('Annual Health Exam');
    const isVaccinationExpensesSelected = medicalExpensesTugoSelected.includes('Vaccination Expenses');
    const isbloodPlasmaOrWholeBloodTransfusionSelected = medicalExpensesTugoSelected.includes('Blood plasma or whole blood (transfusion)');
    const isAnaesthesiologySelected = medicalExpensesTugoSelected.includes('Anaesthesiology');
    const isDentalSurgerySelected = medicalExpensesTugoSelected.includes('Dental Surgery');
    const isYourClaimRelatedToPsychiatricTreatmentChecked = isYourClaimRelatedToPsychiatricTreatment === 'yes';
    const isYourClaimRelatedToHIVChecked = isYourClaimRelatedToHIV === 'yes';
    const isHospitalizationChargesChecked = isYourClaimRelatedToHIV === 'no';

    // Reuse listDocuments from mapDocumentItems instead of rebuilding
    const list = [...listDocuments];
    if (!list.length) {
      return null;
    }

    let renderStepCancellationAdditional = true;
    let renderStepOverseasMedical = true;
    let renderStepPersonalItems = true;
    let renderStepRentalVehicle = true;
    let renderStepOther = true;
    // need to reorder list
    let flag = false;
    for (let x = 0; x < list.length; x++) {
      if (((stepOverseasMedicalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 1;
      } else if (((stepCancellationAdditionalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 3;
      } else if (((stepPersonalItemsExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 2;
      } else if ((Object.values(stepRentalVehicleExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 4;
        // trawick specific sections
        // travel interruption
      } else if (((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Interruption' && travelInterruption === 'true')).length > 0 && !flag) {
        flag = true;
        list[x].description = 'Trip Interruption';
        list[x].order = 4;
        renderStepRentalVehicle = false;
        renderStepCancellationAdditional = false;
      } else if (((stepBaggageAndPersonalItemsExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 2;
        renderStepPersonalItems = false;
        renderStepCancellationAdditional = false;
        // Accidental Death & Dismemberment
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Accidental Death & Dismemberment' && areYouClaimingForAccidentalDeathAndDismemberment === 'true')).length > 0) {
        list[x].order = 7;
        renderStepOther = false;
        renderStepCancellationAdditional = false;
        // Repatriation Expenses
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Repatriation Expenses' && areYouClaimingForRepatriationExpenses === 'true')).length > 0) {
        list[x].order = 8;
        renderStepOther = false;
        renderStepCancellationAdditional = false;
        // Burial Expenses
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Burial Expenses' && areYouClaimingForBurialExpenses === 'true')).length > 0) {
        list[x].order = 9;
        renderStepOther = false;
        renderStepCancellationAdditional = false;
        // medical expenses
      } else if (!showZurichUHC && ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 1;
        renderStepOverseasMedical = false;
        renderStepCancellationAdditional = false;
        // medical expenses step
      } else if (((stepMedicalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 10;
        // Trip Cancellation step
      } else if (((stepTripCancellationLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 11;
        // Trip Interruption step
      } else if (((stepTripInterruptionLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 12;
        // Trip Delay step
      } else if (((stepTripDelayLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Delay' && tripDelay === 'true')).length > 0) {
        list[x].order = 13;
        // Missed Connection step
      } else if (((stepMissedConnectionLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 14;
        // Pet Medical step
      } else if (((stepPetMedicalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 15;
      } else if (((stepPropertyDamageExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 17;
        // Accidental Death and Dismemberment
      } else if (((stepAccidentalDeathAndDismembermentLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 18;
      } else if (((itineraryChangeLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 19;
      } else if (((stepMedicalExpenseCFLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 20;
      } else if (((baggagePersonalEffectsLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 21;
      } else if (((stepTripCancellationCFLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Cancellation' && tripCancellationCF === 'true')).length > 0) {
        list[x].order = 23;
      } else if (((stepTripCancellationCFLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Delay' && travelDelayCF === 'true')).length > 0) {
        list[x].order = 24;
      } else if (((stepTripCancellationCFLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Interruption CF' && travelInterruptionCF === 'true')).length > 0) {
        list[x].description = 'Trip Interruption';
        list[x].order = 25;
      } else if (((jobLossHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 26;
      } else if (((disasterAssistanceHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 27;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.criticalIllness.claimCode)).length > 0) {
        list[x].order = 28;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.disability.claimCode)).length > 0) {
        list[x].order = 29;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.dismemberment.claimCode)).length > 0) {
        list[x].order = 30;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.leaveOfAbsence.claimCode)).length > 0) {
        list[x].order = 31;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.death.claimCode)).length > 0) {
        list[x].order = 32;
      } else if (((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Cancellation' && tripCancellation === 'true')).length > 0) {
        list[x].order = 33;
      } else if (((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Cancellation For Any Reason' && tripCancellationForAnyReason === 'true')).length > 0) {
        list[x].order = 34;
        // travel delay
      } else if (((stepTravelDelayLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Travel Delay & Missed Connections' && travelDelay === 'true')).length > 0) {
        list[x].order = 35;
      } else if (showZurichUHC && ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 36;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Personal Liability' && isPersonalLiabilitySelected)).length > 0) {
        // Personal Liability
        list[x].order = 39;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Personal Accident' && isPersonalAccidentSelected)).length > 0) {
        // Personal Accident
        list[x].order = 40;
      } else if (((stepPersonalAccidentSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 41;
      } else if (((stepRentalVehicleExcessSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 42;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Medical and evacuation' && (isMedicalHospitalExpensesSelected || isDentalExpensesSelected
        || isExpensesarisingfromterrorismSelected || isFuneralExpensesSelected || isExtraTravelAndAccommodationSelected))).length > 0) {
        // Medical and Evacuation SCTI
        list[x].order = 44;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Accompanying Person' && didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true')).length > 0) {
        list[x].order = 45;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Funeral expenses or return of mortal remains' && isFuneralExpensesSelected)).length > 0) {
        list[x].order = 47;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Loss Of Life' && wasTheDeathCausedByAnInjury === 'true')).length > 0) {
        list[x].order = 48;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Baggage delay' && isDaggageDelaySelected)).length > 0) {
        // Baggage and Personal Items SCTI
        list[x].order = 49;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Essential medication' && isEssentialMedicationSelected)).length > 0) {
        list[x].order = 50;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Specified high value items' && isSpecifiedHighValueItemsSelected)).length > 0) {
        list[x].order = 51;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cash, bank cards, travel documents and passports' && (isBankCardsOrTravelDocumentsSelected || isCashSelected))).length > 0) {
        list[x].order = 52;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cancelling or changing your journey before you leave' && (haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true' || wereYouChargedACancellationFeeByTheTravelAgent === 'true'))).length > 0) {
        // Changes to your journey SCTI
        list[x].order = 54;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Existing condition of a relevant person' && wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'true')).length > 0) {
        list[x].order = 55;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Travel Agent Cancellation fee' && wereYouChargedACancellationFeeByTheTravelAgent === 'true')).length > 0) {
        list[x].order = 56;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Delayed journey to a special event' && wereYouDelayedWhileTravelingToASpecialEvent === 'true')).length > 0) {
        list[x].order = 57;
        // } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Travel Agent Cancellation fee' && wereYouChargedACancellationFeeByTheTravelAgentPI === 'true')).length > 0) {
        //   list[x].order = 58;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Changes to your journey once you have left' && haveYouChangedYourJourneyAfterLeaving === 'true')).length > 0) {
        // Changes to your journey once you have left
        list[x].order = 59;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Delayed journey to a special event' && wereYouDelayedWhileTravelingToASpecialEventAL === 'true')).length > 0) {
        list[x].order = 60;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Childcare expenses' && isChildCareExpensesSelected)).length > 0) {
        list[x].order = 61;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Loss of income' && isLossOfIncomeCodeSelected)).length > 0) {
        // Other SCTI
        list[x].order = 62;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Loss of Life' && isLossOfLifeCodeSelected)).length > 0) {
        list[x].order = 63;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Total permanent disablement' && isTotalPermanentDisablementCodeSelected)).length > 0) {
        list[x].order = 64;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Pet services' && isPetBoardingFacilitySelected)).length > 0) {
        // Pet services
        list[x].order = 65;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Existing condition of a relevant person' && wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true')).length > 0) {
        // Existing condition of a relevant person
        list[x].order = 69;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Baggage and Personal Items' && (isDaggageDelaySelected || isEssentialMedicationSelected
        || isSpecifiedHighValueItemsSelected || isJewelleryOrTraditionalWatchesSelected || isUnspecifiedLaptopSelected || isOtherUnspecifiedItemsSelected
        || isBankCardsOrTravelDocumentsSelected || isCashSelected))).length > 0) {
        // Baggage and Personal Items
        list[x].order = 70;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Extra travel and accommodation' && isExtraTravelAndAccommodationSelected)).length > 0) {
        // Extra travel and accommodation
        list[x].order = 71;
      } else if (((stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cash, bank cards, travel documents and passports' && (isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected))).length > 0) {
        // Bank Cards or travel documents and Cash SCTI
        list[x].order = 72;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Outpatient Doctor or Clinic Visit' && isClaimRelatedToSelfInflictedNoChecked)).length > 0) {
        // Medical Expenses Tugo
        list[x].order = 84;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Self Inflicted Injuries and Attempt' && isClaimRelatedToSelfInflictedYesChecked)).length > 0) {
        list[x].order = 85;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'MRI Scans' && isMRIChecked)).length > 0) {
        list[x].order = 86;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Standard X-Ray and Laboratory Examinations' && isNonMRIChecked)).length > 0) {
        list[x].order = 87;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Maternity Expense' && isMaternityExpenseSelected)).length > 0) {
        list[x].order = 88;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Oncology' && isOncologySelected)).length > 0) {
        list[x].order = 89;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cleft Lip and Palate Assistance' && isCleftLipAndPalateAssistanceSelected)).length > 0) {
        list[x].order = 90;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Well Baby Care' && isWellBabyCareSelected)).length > 0) {
        list[x].order = 91;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Annual Health Exam' && isAnnualHealthExamSelected)).length > 0) {
        list[x].order = 92;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Vaccination Expenses' && isVaccinationExpensesSelected)).length > 0) {
        list[x].order = 93;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Hospital Charges Related to Psychiatric Treatment' && isYourClaimRelatedToPsychiatricTreatmentChecked)).length > 0) {
        list[x].order = 94;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Hospital Charges Related to HIV' && isYourClaimRelatedToHIVChecked)).length > 0) {
        list[x].order = 95;
      } else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Hospitalization Charges' && isHospitalizationChargesChecked)).length > 0) {
        list[x].order = 96;
      } else if (((stepOtherTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Blood plasma or whole blood (transfusion)' && isbloodPlasmaOrWholeBloodTransfusionSelected)).length > 0) {
        list[x].order = 97;
      } else if (((stepOtherTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Anaesthesiology' && isAnaesthesiologySelected)).length > 0) {
        list[x].order = 98;
      } else if (((stepOtherTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Dental Surgery' && isDentalSurgerySelected)).length > 0) {
        list[x].order = 99;
      } else if (((stepTripCancellationTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0
        || ((stepTripCancellationTravellerTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        // Trip Cancellation Tugo
        list[x].order = 100;
      } else if (((stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        // Standard VTC Medical Benefits
        list[x].order = 101;
      } else if (((stepTravellerMedicalBenefitsTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        // Traveller Medical Benefits
        list[x].order = 102;
      } else if (((stepOptimumMedicalBenefitsTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        // Optimum Medical Benefits
        list[x].order = 103;
      }
    }

    const renderRequireDoccument = (data) => {
      const isScti = appConfig.reactAppEnv === 'scti' || appConfig.reactAppEnv === 'tugo';
      const expenses = data.expenses || [];
      const isExpenseLevelVersion = jsonVersion > 15;
      const { validationMessages } = this.props.form;

      const documents = (data.requiredDocuments || []).map((doc) => {
        const found = (validationMessages || []).find(
          (msg) => (msg.RequiredDocumentId || msg.requiredDocumentId) === doc.claimRequiredDocumentId
        );
        return {
          ...doc,
          Message: found ? found.Message : '',
          Success: found ? found.Success : undefined,
        };
      });

      if (!documents) {
        return null;
      }

      const selectedBenefits = this.props.stepWhatHappenedData.selectedBenefits;
      const listBenefits = [...(selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || [])];
      const benefit = listBenefits.find((b) => Array.isArray(b.codeList) && b.codeList.includes(data.claimCode)) || {};

      // if (benefit.description === 'Changes to your journey') {
      //   expenses = stepChangesToYourJourneyDataMapper.mapToExpenses(this.props.stepChangesToYourJourneyData);
      // } else if (benefit.description === 'Baggage and Personal Items') {
      //   expenses = stepBaggageAndPersonalItemsStarrDataMapper.mapToExpenses(this.props.stepBaggageAndPersonalItemsStarrData);
      // }
      // else if (benefit.description === 'Medical Expense') {
      //   expenses = stepMedicalExpenseCFDataMapper.mapToExpenses(this.props.stepMedicalExpenseCFData);
      // }

      this.allowValidateDocuments[data.claimTypeId] = expenses.length === 1;
      const hasDocsNeedToValidate = documents.some((doc) => doc.runDocumentValidation === true);
      // Show validation message column when jsonVersion > 15
      const showReviewColumn = jsonVersion > 15 && hasDocsNeedToValidate && this.allowValidateDocuments[data.claimTypeId];
      const hasPendingDocAnywhere = documents.some(doc => doc.Success === null);

      return documents.length > 0 ? (
        <div>
          {isScti
            ? this.renderSCTIRequireDocMessage(documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, intl)
            : this.renderClaimExpenseRequireDocMessage(documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, isExpenseLevelVersion, intl)
          }
        </div>
      ) : (null);
    };

    list.sort((a, b) => {
      const aHasRequiredDocuments = a.requiredDocuments && a.requiredDocuments.length > 0;
      const bHasRequiredDocuments = b.requiredDocuments && b.requiredDocuments.length > 0;
      return bHasRequiredDocuments - aHasRequiredDocuments;
    });
    return list.map((d, idx) => (
      <div key={idx} style={{ backgroundColor: '#f5f5f5', marginLeft: '5px', marginRight: '0', display: d.order === 0 ? 'none' : '' }} className={idx > 0 ? 'row pt-3 mt-4' : 'row pt-3'}>
        <div className="form-group col-md-12">
          <span className="normal-text" style={{ fontWeight: '600' }}>
            {formatClaimTypeDocumentsHeader(intl, d.description)}
          </span>
          <span className="normal-text"> - <FormattedMessage {...messages.provideAllRelevantToClaim} /></span>
        </div>
        {newVersion && d.requiredDocuments && d.requiredDocuments.some(doc => doc.runDocumentValidation === true) && this.renderInstructions()}
        {newVersion &&
          <div style={{ paddingRight: '0', width: '100%' }}>
            {d.order === 3 && renderRequireDoccument(d) && renderStepCancellationAdditional}
            {d.order === 2 && renderRequireDoccument(d) && renderStepPersonalItems}
            {d.order === 4 && renderRequireDoccument(d) && renderStepRentalVehicle}
            {d.order === 5 && renderRequireDoccument(d) && renderStepOther}
            {/* trawick medical expenses */}
            {d.order === 1 && renderRequireDoccument(d)}
            {/* trawick trip interruption and delay */}
            {d.order === 4 && travelInterruption === 'true' && renderRequireDoccument(d)}
            {/* trawick baggage and personal */}
            {d.order === 2 && renderRequireDoccument(d)}
            {/* trawick other */}
            {d.order === 7 && areYouClaimingForAccidentalDeathAndDismemberment === 'true' && renderRequireDoccument(d)}
            {d.order === 8 && areYouClaimingForRepatriationExpenses === 'true' && renderRequireDoccument(d)}
            {d.order === 9 && areYouClaimingForBurialExpenses === 'true' && renderRequireDoccument(d)}
            {d.order === 10 && renderRequireDoccument(d)}
            {d.order === 11 && renderRequireDoccument(d)}
            {d.order === 12 && renderRequireDoccument(d)}
            {d.order === 13 && renderRequireDoccument(d)}
            {d.order === 14 && renderRequireDoccument(d)}
            {d.order === 15 && renderRequireDoccument(d)}
            {/* {d.order === 16 && renderRequireDoccument(d)} */}
            {d.order === 17 && renderRequireDoccument(d)}
            {d.order === 18 && renderRequireDoccument(d)}
            {d.order === 19 && renderRequireDoccument(d)}
            {d.order === 20 && renderRequireDoccument(d)}
            {d.order === 21 && renderRequireDoccument(d)}
            {d.order === 23 && tripCancellationCF === 'true' && renderRequireDoccument(d)}
            {d.order === 24 && travelDelayCF === 'true' && renderRequireDoccument(d)}
            {d.order === 25 && travelInterruptionCF === 'true' && renderRequireDoccument(d)}
            {d.order === 26 && <JobLossHardshipStepShared />}
            {d.order === 27 && <DisasterAssistanceHardshipStepShared />}
            {d.order === 28 && <CriticalIllnessStepShared />}
            {d.order === 29 && <DisabilityStepShared />}
            {d.order === 30 && <DismembermentStepShared />}
            {d.order === 31 && <LeaveOfAbsenceStepShared />}
            {d.order === 32 && <DeathStepShared />}
            {d.order === 33 && tripCancellation === 'true' && renderRequireDoccument(d)}
            {d.order === 34 && tripCancellationForAnyReason === 'true' && renderRequireDoccument(d)}
            {d.order === 35 && travelDelay === 'true' && renderRequireDoccument(d)}
            {d.order === 39 && renderRequireDoccument(d)}
            {d.order === 40 && renderRequireDoccument(d)}
            {d.order === 41 && renderRequireDoccument(d)}
            {d.order === 42 && renderRequireDoccument(d)}
            {/* {d.order === 43 && renderRequireDoccument(d)} */}
            {/* Medical and Evacuation SCTI */}
            {d.order === 44 && renderRequireDoccument(d)}
            {d.order === 45 && renderRequireDoccument(d)}
            {d.order === 47 && renderRequireDoccument(d)}
            {d.order === 48 && renderRequireDoccument(d)}
            {/* Baggage and Personal Items SCTI */}
            {d.order === 49 && renderRequireDoccument(d)}
            {d.order === 50 && renderRequireDoccument(d)}
            {d.order === 51 && renderRequireDoccument(d)}
            {d.order === 52 && renderRequireDoccument(d)}
            {/* Changes to your journey */}
            {d.order === 54 && renderRequireDoccument(d)}
            {d.order === 55 && renderRequireDoccument(d)}
            {d.order === 56 && renderRequireDoccument(d)}
            {d.order === 57 && renderRequireDoccument(d)}
            {d.order === 58 && renderRequireDoccument(d)}
            {d.order === 59 && renderRequireDoccument(d)}
            {d.order === 60 && renderRequireDoccument(d)}
            {d.order === 61 && renderRequireDoccument(d)}
            {d.order === 62 && renderRequireDoccument(d)}
            {d.order === 63 && renderRequireDoccument(d)}
            {d.order === 64 && renderRequireDoccument(d)}
            {/* Pet services */}
            {d.order === 65 && renderRequireDoccument(d)}
            {/* Cancelling or changing your journey before you leave NZ-EXCON-RP */}
            {d.order === 69 && renderRequireDoccument(d)}
            {/* Baggage and Personal Items */}
            {d.order === 70 && renderRequireDoccument(d)}
            {/* Extra travel and accommodation */}
            {d.order === 71 && renderRequireDoccument(d)}
            {/* // Bank Cards or travel documents and Cash SCTI */}
            {d.order === 72 && renderRequireDoccument(d)}
            {/* Medical Expenses Tugo */}
            {(d.order >= 84 && d.order <= 99) && renderRequireDoccument(d)}
            {/* Trip Cancellation Tugo */}
            {d.order === 100 && renderRequireDoccument(d)}
            {/* Standard VTC Medical Benefits */}
            {d.order === 101 && renderRequireDoccument(d)}
            {/* Traveller Medical Benefits */}
            {d.order === 102 && renderRequireDoccument(d)}
            {/* Optimum Medical Benefits */}
            {d.order === 103 && renderRequireDoccument(d)}
            {/* Other Tugo */}
            {(d.order === null) && renderRequireDoccument(d, attachDocuments)}
          </div>
        }
        {!newVersion &&
          <div style={{ paddingRight: '0', width: '100%' }}>
            {d.order === 3 && <StepCancellationAdditionalShared /> && renderStepCancellationAdditional}
            {d.order === 2 && <StepPersonalItemsShared /> && renderStepPersonalItems}
            {d.order === 1 && <StepOverseasMedicalShared /> && renderStepOverseasMedical}
            {d.order === 4 && <StepRentalVehicleShared /> && renderStepRentalVehicle}
            {/* {d.order === 6 && <StepSnowSportsShared />} */}
            {d.order === 5 && <StepOtherShared /> && renderStepOther}
            {/* trawick medical expenses */}
            {d.order === 1 && <StepMedicalExpensesShared />}
            {/* trawick trip interruption and delay */}
            {d.order === 4 && travelInterruption === 'true' && <TripInterruptionStepShared />}
            {/* trawick baggage and personal */}
            {d.order === 2 && <StepBaggageAndPersonalItemsShared />}
            {/* trawick other */}
            {/* {d.order === 5 && <Step17Shared />} */}
            {d.order === 7 && areYouClaimingForAccidentalDeathAndDismemberment === 'true' && <StepOtherSharedForAD />}
            {d.order === 8 && areYouClaimingForRepatriationExpenses === 'true' && <StepOtherSharedForRepatriationExpenses />}
            {d.order === 9 && areYouClaimingForBurialExpenses === 'true' && <StepOtherSharedForBurialExpenses />}
            {d.order === 10 && <MedicalExpenseStepShared />}
            {d.order === 11 && <TripCancellationStepShared />}
            {d.order === 12 && <TripInterruptionStepShared />}
            {d.order === 13 && <TripDelayStepShared />}
            {d.order === 14 && <MissedConnectionStepShared />}
            {d.order === 15 && <PetMedicalStepShared />}
            {d.order === 16 && <CollisionDamageStepShared />}
            {d.order === 17 && <PropertyDamageStepShared />}
            {d.order === 18 && <AccidentalDeathAndDismembermentStepShared />}
            {d.order === 19 && <ItineraryChangeStepShared />}
            {d.order === 20 && <MedicalExpenseCFStepShared />}
            {d.order === 21 && <BaggagePersonalEffectsShared />}
            {d.order === 23 && tripCancellationCF === 'true' && <TripCancellationCFStepShared />}
            {d.order === 24 && travelDelayCF === 'true' && <TripDelayCFStepShared />}
            {d.order === 25 && travelInterruptionCF === 'true' && <TripInterruptionCFStepShared />}
            {d.order === 26 && <JobLossHardshipStepShared />}
            {d.order === 27 && <DisasterAssistanceHardshipStepShared />}
            {d.order === 28 && <CriticalIllnessStepShared />}
            {d.order === 29 && <DisabilityStepShared />}
            {d.order === 30 && <DismembermentStepShared />}
            {d.order === 31 && <LeaveOfAbsenceStepShared />}
            {d.order === 32 && <DeathStepShared />}
            {d.order === 33 && tripCancellation === 'true' && <TripCancellationCFStepShared />}
            {d.order === 34 && tripCancellationForAnyReason === 'true' && <TripCancellationCFStepShared />}
            {d.order === 35 && travelDelay === 'true' && <StepTripCancellationAndTripInterruptionSharedTravelDelay />}
            {d.order === 36 && <MedicalExpenseZurichStepShared />}
            {d.order === 39 && isPersonalLiabilitySelected && <StepOtherSharedForRepatriationExpenses />}
            {d.order === 40 && isPersonalAccidentSelected && <StepOtherSharedForBurialExpenses />}
            {d.order === 41 && <StepPersonalAccidentSCTIShared />}
            {d.order === 42 && <StepRentalVehicleExcessSCTIShared />}
            {d.order === 43 && <StepCashBankCardsTravelDocumentsAndPassportsShared />}
            {/* Medical and Evacuation SCTI */}
            {d.order === 44 && <StepMedicalAndEvacuationShared />}
            {/* Baggage and Personal Items SCTI */}
            {d.order === 47 && <StepBaggageAndPersonalItemsSCTIShared />}
            {/* Changes to your journey */}
            {d.order === 52 && <StepChangesToYourJourneyShared />}
          </div>
        }
        <div className="form-group col-md-12">
          <b><FormattedMessage {...messages.SupportingDocs} id={messages.SupportingDocs.id} /></b> - <span className="normal-text"><FormattedMessage {...messages.UploadAny} id={messages.UploadAny.id} /></span>
        </div>
        <div className="form-group col-md-12">
          <AttachSupportingDocuments
            claimCode={d.claimCode}
            data={attachDocuments}
            onChange={onAttachDocumentChange.bind(this, d.claimCode)}
            onDelete={onFileRemove}
            disabled={isReadOnly}
          />
        </div>
      </div>
    ));
  };

  getTranslatedDescription = (document, intl) => {
    if (!document) return '';
    if (!intl) return document.requiredDocumentDescription || '';
    const locale = (intl.locale || 'en').toLowerCase();
    const baseLocale = locale.split('-')[0];
    if (document.translations) {
      const normalizedTranslations = {};
      Object.keys(document.translations).forEach((key) => {
        normalizedTranslations[key.toLowerCase()] = document.translations[key];
      });
      if (normalizedTranslations[locale]) return normalizedTranslations[locale];
      if (normalizedTranslations[baseLocale]) return normalizedTranslations[baseLocale];
      const match = Object.keys(normalizedTranslations).find(
        (key) => key.startsWith(`${baseLocale}-`) || key === baseLocale
      );
      if (match) return normalizedTranslations[match];
    }
    return document.requiredDocumentDescription || '';
  };
  renderClaimExpenseRequireDocMessage = (documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, isExpenseLevelVersion, intl) => (
    <div style={{ width: '100%' }}>
      <Table style={{ tableLayout: 'fixed', width: '100%' }}>
        <thead>
          <TR>
            <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '50%' }}>
              <FormattedMessage {...messages.DocDocument} id={messages.DocDocument.id} />
            </TH>
            <TH className="document-table-top document-table-left align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: showReviewColumn ? '25%' : '50%' }}>
              <FormattedMessage {...messages.DocUploaded} id={messages.DocUploaded.id} />
            </TH>
            <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
              {showReviewColumn && (
                <FormattedMessage {...messages.InitialDocumentReview} id={messages.InitialDocumentReview.id} />
              )}
            </TH>
          </TR>
        </thead>
        {isExpenseLevelVersion &&
          <tbody>
            <TR
              className="no-hover"
              style={{ pointerEvents: 'none' }}
            >
              <TD colSpan={showReviewColumn ? 3 : 3} style={{ border: 'none' }}>
                <Section>
                  <ControlContainer>
                    <strong>General documents required</strong>
                  </ControlContainer>
                </Section>
              </TD>
            </TR>
            {documents.filter((doc) => doc.displayCode !== REQUIRED_DOCUMENT_DISPLAY_CODE.OneDocRequiredPerBenefitExpense).map((document, idx) => (
              <TR key={idx}>
                <TD className="tooltip-container" style={{ border: 'none' }}>
                  {idx + 1}. {this.getTranslatedDescription(document, intl)}
                  {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                  {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
                </TD>
                <TD className="text-left">
                  <div>
                    <ShowSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                      requiredDocumentId={document.claimRequiredDocumentId}
                      claimExpenseGuid={''}
                    />
                    <UploadSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                    />
                  </div>
                </TD>
                <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                  {showReviewColumn && (
                    <ShowPBValidationMesssage
                      document={document}
                      attachDocuments={attachDocuments}
                      hasPendingDocAnywhere={hasPendingDocAnywhere}
                      onRunValidation={this.onRunValidation}
                      isReadOnly={isReadOnly}
                      data={data}
                      onCancelValidation={this.onCancelValidation}
                    />
                  )}
                </TD>
              </TR>
            ))}
            {expenses.map((expense, expenseIdx) => [
              <TR
                key={`expense-header-${expenseIdx}`}
                className="no-hover"
                style={{ pointerEvents: 'none' }}
              >
                <TD colSpan={showReviewColumn ? 3 : 3} style={{ border: 'none' }}>
                  <Section>
                    <ControlContainer>
                      <strong>Documents for Expense {expenseIdx + 1}:</strong>
                      <br />
                      Name of organization: {expense.shortDescription}
                      <br />
                      Description of expense: {expense.shortDescription}
                      <br />
                      Amount claimed: {expense.currency} {expense.clientCost}
                      <br />
                      Reimbursement received: {expense.reimbursementReceived}
                    </ControlContainer>
                  </Section>
                </TD>
              </TR>,
              documents.filter((doc) => doc.displayCode === REQUIRED_DOCUMENT_DISPLAY_CODE.OneDocRequiredPerBenefitExpense).map((document, idx) => (
                <TR key={`expense-${expenseIdx}-doc-${idx}`}>
                  <TD className="tooltip-container" style={{ border: 'none' }}>
                    {idx + 1}. {this.getTranslatedDescription(document, intl)}
                    {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                    {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
                  </TD>
                  <TD className="text-left">
                    <div>
                      <ShowSupportingDocuments
                        claimCode={data.claimCode}
                        data={attachDocuments}
                        onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, expense.claimExpenseGuid, document.displayCode)}
                        onDelete={onFileRemove}
                        disabled={isReadOnly}
                        requiredDocumentId={document.claimRequiredDocumentId}
                        claimExpenseGuid={expense.claimExpenseGuid}
                      />
                      <UploadSupportingDocuments
                        claimCode={data.claimCode}
                        data={attachDocuments}
                        onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, expense.claimExpenseGuid, document.displayCode)}
                        onDelete={onFileRemove}
                        disabled={isReadOnly}
                      />
                    </div>
                  </TD>
                  <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                    {showReviewColumn && (
                      <ShowPBEValidationMesssage
                        document={document}
                        attachDocuments={attachDocuments}
                        expense={expense}
                        hasPendingDocAnywhere={hasPendingDocAnywhere}
                        onRunValidation={this.onRunValidation}
                        onCancelValidation={this.onCancelValidation}
                        isReadOnly={isReadOnly}
                        data={data}
                      />
                    )}
                  </TD>
                </TR>
              ))
            ]).flat()}
          </tbody>
        }
        {!isExpenseLevelVersion &&
          <tbody>
            {documents.map((document, idx) => (
              <TR key={idx}>
                <TD className="tooltip-container" style={{ border: 'none' }}>
                  {idx + 1}. {this.getTranslatedDescription(document, intl)}
                  {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                  {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
                </TD>
                <TD className="text-left">
                  <div>
                    <ShowSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                      requiredDocumentId={document.claimRequiredDocumentId}
                      claimExpenseGuid={''}
                    />
                    <UploadSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                    />
                  </div>
                </TD>
                <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                  {showReviewColumn && (
                    <ShowPBValidationMesssage
                      document={document}
                      attachDocuments={attachDocuments}
                      hasPendingDocAnywhere={hasPendingDocAnywhere}
                      onRunValidation={this.onRunValidation}
                      isReadOnly={isReadOnly}
                      data={data}
                      onCancelValidation={this.onCancelValidation}
                    />
                  )}
                </TD>
              </TR>
            ))}
          </tbody>
        }
      </Table >
    </div>
  );

  renderSCTIRequireDocMessage = (documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, intl) => (
    <div style={{ width: '100%' }}>
      <Table style={{ tableLayout: 'fixed', width: '100%' }}>
        <thead>
          <TR>
            <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '50%' }}>
              <FormattedMessage {...messages.DocDocument} id={messages.DocDocument.id} />
            </TH>
            <TH className="document-table-top document-table-left align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: showReviewColumn ? '25%' : '50%' }}>
              <FormattedMessage {...messages.DocUploaded} id={messages.DocUploaded.id} />
            </TH>
            <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
              {showReviewColumn && (
                <FormattedMessage {...messages.InitialDocumentReview} id={messages.InitialDocumentReview.id} />
              )}
            </TH>
          </TR>
        </thead>
        <tbody>
          {documents.map((document, idx) => (
            <TR key={idx}>
              <TD className="tooltip-container" style={{ border: 'none' }}>
                {idx + 1}. {this.getTranslatedDescription(document, intl)}
                {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
              </TD>
              <TD className="text-left">
                <ShowSupportingDocuments
                  claimCode={data.claimCode}
                  data={attachDocuments}
                  onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', document.displayCode)}
                  onDelete={onFileRemove}
                  disabled={isReadOnly}
                  requiredDocumentId={document.claimRequiredDocumentId}
                />
                <UploadSupportingDocuments
                  claimCode={data.claimCode}
                  data={attachDocuments}
                  onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', document.displayCode)}
                  onDelete={onFileRemove}
                  disabled={isReadOnly}
                />
              </TD>
              <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                {showReviewColumn && (() => {
                  const hasRunValidation = document.Success === true || document.Success === false;
                  const hasPendingDoc = document.Success === null;

                  const documentSuccess = document.Success;
                  const documentMessage = document.Message;

                  const tooltipContent = "We've detected potential issues with your selected document.\nIf you believe this is an error, you can still proceed with submitting your claim.";

                  // Check if this specific document has any attachments uploaded
                  const hasAttachmentForThisDocument = attachDocuments.some(
                    attachment => attachment.requiredDocumentId === document.claimRequiredDocumentId
                  );

                  return (
                    <div>
                      {hasPendingDoc ? (
                        <div>
                          <div
                            style={{
                              backgroundColor: '#FFF9C4',
                              padding: '10px',
                              borderRadius: '6px',
                              display: 'flex',
                              alignItems: 'center',
                              color: '#bfa100'
                            }}
                          >
                            <span
                              role="img"
                              aria-label="Validating"
                              style={{
                                color: '#bfa100',
                                marginRight: '8px',
                                fontSize: '16px',
                              }}
                            >
                              ⌛
                            </span>
                            <span>Validating...</span>

                          </div>
                          <button
                            className="btn btn-sm btn-primary mt-2"
                            onClick={() => this.onCancelValidation(document.claimRequiredDocumentId, data.claimTypeId)}
                          >
                            Cancel Validation
                          </button>
                        </div>
                      ) : documentSuccess === true ? (
                        <div
                          style={{
                            backgroundColor: '#DDFFDD',
                            padding: '10px',
                            borderRadius: '6px',
                            position: 'relative',
                            color: '#2e7d32',
                          }}
                        >
                          <div>
                            <span
                              style={{
                                color: '#4CAF50',
                                marginRight: '8px',
                                fontSize: '18px',
                                fontWeight: 'bold',
                              }}
                            >
                              ✓
                            </span>
                            <span>
                              {documentMessage || 'Document accepted.'}
                            </span>
                          </div>
                        </div>
                      ) : documentSuccess === false && documentMessage && hasAttachmentForThisDocument ? (
                        <div
                          style={{
                            backgroundColor: '#FFDDDD',
                            padding: '10px',
                            borderRadius: '6px',
                            color: '#c62828',
                            position: 'relative',
                            paddingRight: '30px',
                            marginBottom: '8px',
                          }}
                        >
                          <span
                            style={{
                              position: 'absolute',
                              top: '8px',
                              right: '8px',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              backgroundColor: '#1976d2',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            title={tooltipContent.replace('\n', '\r\n')}
                            data-toggle="tooltip"
                            data-html="true"
                            data-placement="top"
                          >
                            i
                          </span>

                          {documentMessage.split(/<br\s*\/?>/gi).map((line, lineIndex) => (
                            line.trim() && (
                              <div key={`line-${lineIndex}`}>
                                <span
                                  style={{
                                    color: '#F44336',
                                    marginRight: '8px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  ✕
                                </span>
                                <span>
                                  {line.trim()}
                                </span>
                              </div>
                            )
                          ))}
                        </div>
                      ) : (() => {
                        // Only show "Document accepted" if document has attachment and runDocumentValidation is false
                        return document.runDocumentValidation === false && hasAttachmentForThisDocument ? (
                          <div
                            style={{
                              backgroundColor: '#DDFFDD',
                              padding: '10px',
                              borderRadius: '6px',
                              position: 'relative',
                              color: '#2e7d32',
                            }}
                          >
                            <div>
                              <span
                                style={{
                                  color: '#4CAF50',
                                  marginRight: '8px',
                                  fontSize: '18px',
                                  fontWeight: 'bold',
                                }}
                              >
                                ✓
                              </span>
                              <span>Document accepted.</span>
                            </div>
                          </div>
                        ) : null;
                      })()}

                      {(() => {
                        if (!hasPendingDocAnywhere && document.runDocumentValidation !== false && hasAttachmentForThisDocument) {
                          return (
                            <div className="row align-items-center justify-content-center">
                              <div className="col-auto">
                                <button
                                  className="btn btn-sm btn-primary mt-2"
                                  onClick={() => this.onRunValidation([], document.claimRequiredDocumentId, data.claimTypeId)}
                                  disabled={isReadOnly}
                                >
                                  {hasRunValidation ? 'Check Again' : 'Check My Documents'}
                                </button>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  );
                })()}
              </TD>
            </TR>
          ))}
        </tbody>
      </Table>
    </div>
  );

  renderSCTIWarningMessage = (isReadOnly, warningMissingRequiredDocument) => (
    <div>
      <P>
        <FormattedMessage {...messages.youHaveNotAttachedAnyRequiredDocumentsForYourClaimSCTI} />
      </P>
      <P>
        <FormattedMessage {...messages.warningMissingRequiredDocumentDetailsSCTI} />
      </P>
      <P>
        <FormattedMessage {...messages.youMayAlsoSaveThisClaimAsADraftAndReturnAnytimeWithin30DaysOfCommencementToAttachTheRequiredDocumentsSCTI} />
      </P>
      <div className="row">
        <div className="form-group col-md-12">
          <FlexBox>
            <OptionsContainer>
              <FormattedMessage {...messages.wouldYouLikeToProceedToNextStepsSCTI} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="true"
                checked={warningMissingRequiredDocument === 'true'}
                onChange={this.handleChange('form.warningMissingRequiredDocument')}
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="false"
                checked={warningMissingRequiredDocument === 'false'}
                onChange={this.handleChange('form.warningMissingRequiredDocument')}
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </div>
      </div>
    </div>
  );

  renderInstructions() {
    return (
      <div className="col-md-12 pt-3 px-3">
        <i>Kindly follow instructions carefully:</i>
        <ul className="mt-2">
          <li>For each <b>Document</b> section in the table below, provide relevant supporting documents. Ensure the documents are easy to read and the details match the claim as clearly as possible.</li>
          <li>If necessary, you can attach more than one document per <b>Document</b> row. For example, if your itinerary consists of 3 pages and they have been individually scanned or photographed, attach all 3 in the same <b>Document</b> row.</li>
          <li>If you receive a red warning block but believe the validation misunderstood or missed something, please ignore the warning and proceed with your claim.</li>
          <li>If you need to update claim details on a different screen or upload a different document, click the blue <b>Check Again</b> button to check for remaining warnings.</li>
        </ul>
      </div>
    );
  }

  renderStandardWarningMessage = (showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, isReadOnly, warningMissingRequiredDocument) => {
    return (
      <div>
        <Section>
          <ControlContainer>
            {showWarningMissingRequiredDocument && (
              <div>
                <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                  <FormattedMessage {...messages.warningMissingRequiredDocument} />
                </h5>
                <P>
                  <FormattedMessage {...messages.warningMissingRequiredDocumentText1} />
                </P>
              </div>
            )}

            {showWarningInvalidRequiredDocument && (
              <div>
                <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                  <FormattedMessage {...messages.warningInvalidRequiredDocument} />
                </h5>
                <P>
                  <FormattedMessage {...messages.warningInvalidRequiredDocumentText1} />
                </P>
              </div>
            )}

            <div className={'row'}>
              <div className={'form-group col-md-12'}>
                <FlexBox>
                  <OptionsContainer>
                    <FormattedMessage {...messages.wouldYouLikeToProceedToNextSteps} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={warningMissingRequiredDocument === 'true'}
                      onChange={this.handleChange('form.warningMissingRequiredDocument')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={warningMissingRequiredDocument === 'false'}
                      onChange={this.handleChange('form.warningMissingRequiredDocument')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          </ControlContainer>
        </Section>
      </div>
    );
  }

  renderWarningMissingRequiredDocument = (showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, warningMissingRequiredDocument, isReadOnly) => {
    const isScti = appConfig.reactAppEnv === 'scti';
    return (
      <div>
        <Section>
          <ControlContainer>
            {/* <h5 style={{ fontWeight: 'bold', color: 'red' }}>
              <FormattedMessage {...messages.warningMissingRequiredDocument} />
            </h5> */}
            {isScti
              ? this.renderSCTIWarningMessage(isReadOnly, warningMissingRequiredDocument)
              : this.renderStandardWarningMessage(showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, isReadOnly, warningMissingRequiredDocument)
            }
          </ControlContainer>
        </Section>
      </div>
    );
  };

  onCancelValidation(requiredDocumentId, claimTypeId) {
    const { onCancelRequiredDocValidation } = this.props;
    onCancelRequiredDocValidation(requiredDocumentId, claimTypeId);
  }

  render() {
    const {
      attachDocuments,
      uploadPercentage,
      progressBarVisibility,
      showWarningMissingRequiredDocument,
      showWarningInvalidRequiredDocument,
      warningMissingRequiredDocument,
    } = this.props.form;
    const { isSummary, submitted, loading, intl, showRequiredDocument } = this.props;
    const isReadOnly = submitted || isSummary;
    const isNextStep = !showRequiredDocument || ((!showWarningMissingRequiredDocument && !showWarningInvalidRequiredDocument) ? true : warningMissingRequiredDocument === 'true');
    const { invalidFileName, isLongFileName, listDocuments } = this.state;
    const effectiveHasFormChanges = this.props.hasFormChanges && !progressBarVisibility;
    return (
      <div className="app-content">

        <Section className="text-center">
          <P className="mb-0 normal-text"><FormattedMessage {...messages.provideAll} id={messages.provideAll.id} /></P>
        </Section>
        <Section>
          <ProgressBar
            percent={uploadPercentage}
            style={{ display: progressBarVisibility ? '' : 'none' }}
            trailColor="#D9D9D9"
            strokeColor="#2db7f5"
          />
        </Section>
        {this.renderUploadAreaForBenefits(listDocuments, attachDocuments, this.onAttachDocumentChange, this.onAttachRequiredDocumentChange, this.handleFileRemove, isReadOnly)}
        {this.props.stepOtherInsuranceCoverageTugoData &&
          this.props.stepOtherInsuranceCoverageTugoData.hasProvincialHealthCoverage === 'true' && (
            <div style={{ backgroundColor: '#f5f5f5', marginLeft: '5px', marginRight: '0' }} className="row pt-3 mt-4">
              <div className="form-group col-md-12">
                <span className="normal-text" style={{ fontWeight: '600' }}>
                  Other Insurance coverage document
                </span>
                <span className="normal-text"> - <FormattedMessage {...messages.provideAllRelevantToClaim} id={messages.provideAllRelevantToClaim.id} /></span>
              </div>
              <div style={{ paddingRight: '0', width: '100%' }}>
                <Table>
                  <thead>
                    <TR>
                      <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
                        <FormattedMessage {...messages.DocDocument} id={messages.DocDocument.id} />
                      </TH>
                      <TH className="document-table-top ddocument-table-left align-middle" color={'#000000'} backgroundColor={'#fff'}>
                        <FormattedMessage {...messages.DocUploaded} id={messages.DocUploaded.id} />
                      </TH>
                    </TR>
                  </thead>
                  <tbody>
                    <TR>
                      <TD className="tooltip-container" style={{ border: 'none' }}>
                        Documentation showing provincial or territorial health insurance coverage (e.g. health card, coverage confirmation letter).
                        <span style={{ color: 'red' }}> *</span>
                      </TD>
                      <TD className="text-left">
                        <AttachSupportingDocuments
                          claimCode="PROVINCIAL_HEALTH_COVERAGE"
                          data={attachDocuments}
                          onChange={(files) => this.onAttachDocumentChange('PROVINCIAL_HEALTH_COVERAGE', files, 'Other Insurance coverage document')}
                          onDelete={this.handleFileRemove}
                          disabled={isReadOnly}
                          hideDragHint
                        />
                      </TD>
                    </TR>
                  </tbody>
                </Table>
              </div>
            </div>
          )}
        {showRequiredDocument && (showWarningMissingRequiredDocument || showWarningInvalidRequiredDocument) && this.renderWarningMissingRequiredDocument(showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, warningMissingRequiredDocument, isReadOnly)}
        {!isSummary && (
          <div className="mt-3">
            <WizardNavigationButtons
              onBack={this.props.prev}
              onNext={this.handleNext}
              onSave={this.handleSaveButtonClick}
              canMoveNext={isNextStep}
              listLength={1}
              submitted={submitted}
              loading={loading}
              saveButtonId={this.saveButtonId}
              showSpinnerForElement={this.showSpinnerForElement}
              handleKeyDown={this.handleKeyDown}
              intl={intl}
              hasFormChanges={effectiveHasFormChanges}
              nextButtonRef={(ref) => {
                this.nextButton = ref;
              }}
              backDisabled={progressBarVisibility}
              saveDisabled={progressBarVisibility}
              nextDisabled={progressBarVisibility || !isNextStep}
            />
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
        <ModalError isLongFileName={isLongFileName} isOpen={invalidFileName} onClose={this.hideModal} />
      </div>
    );
  }
}
StepSupportingDocuments.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFileUpload: PropTypes.func,
  onFileRemove: PropTypes.func,
  onRequireDocFileUpload: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  onFormDataSave: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
  stepTripCancellationAndTripInterruptionData: PropTypes.any,
  stepOtherData: PropTypes.any,
  stepTripCancellationCFData: PropTypes.any,
  stepTravelDelayData: PropTypes.any,
  stepTripDelayData: PropTypes.any,
  stepMedicalAndEvacuationSCTIData: PropTypes.any,
  stepBaggageAndPersonalItemsSCTIData: PropTypes.any,
  stepChangesToYourJourneySCTIData: PropTypes.any,
  stepChangesToYourJourneyData: PropTypes.any,
  stepBaggageAndPersonalItemsData: PropTypes.any,
  stepBaggageAndPersonalItemsStarrData: PropTypes.any,
  stepMedicalExpenseCFData: PropTypes.any,
  stepOtherStarrData: PropTypes.any,
  stepCollisionDamageStarrData: PropTypes.any,
  stepCollisionDamageData: PropTypes.any,
  stepCashBankCardsTravelDocumentsAndPassportsData: PropTypes.any,
  stepMedicalExpensesTugoData: PropTypes.any,
  stepOtherTugoData: PropTypes.any,
  stepBaseVictorsMedicalTugoData: PropTypes.any,
  stepStudentMedicalBenefitsTugoData: PropTypes.any,
  stepTripCancellationTugoData: PropTypes.any,
  stepTripCancellationTravellerTugoData: PropTypes.any,
  stepTripInterruptionTugoData: PropTypes.any,
  stepStandardVTCMedicalBenefitsTugoData: PropTypes.any,
  stepTravellerMedicalBenefitsTugoData: PropTypes.any,
  stepOptimumMedicalBenefitsTugoData: PropTypes.any,
  stepADAndDBenefitsTugoData: PropTypes.any,
  stepOtherInsuranceCoverageTugoData: PropTypes.any,
  stepBaggageAndPersonalItemsTravellerTugoData: PropTypes.any,
  stepRentalCarProtectionTravellerTugoData: PropTypes.any,
  stepMedicalExpensesData: PropTypes.any,
  claimTypesInit: PropTypes.any,
  jsonVersion: PropTypes.string,
  showRequiredDocument: PropTypes.bool,
  policyTypeCode: PropTypes.string,
  policyPlanIds: PropTypes.any,
  showZurichUHC: PropTypes.bool,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  intl: intlShape.isRequired,
  onRunRequiredDocValidation: PropTypes.func,
  onCancelRequiredDocValidation: PropTypes.func,
  hasFormChanges: PropTypes.bool,
  setFormHasChanges: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepSupportingDocuments(),
  loading: makeSelectProgressBarStatus(),
  stepWhatHappenedData: makeSelectStepWhatHappened(),
  stepTripCancellationAndTripInterruptionData: makeSelectStepTripCancellationAndTripInterruption(),
  stepOtherData: makeSelectStepOther(),
  stepTripCancellationCFData: makeSelectTripCancellationCFStep(),
  stepTravelDelayData: makeSelectStepTravelDelay(),
  stepTripDelayData: makeSelectTripDelayStep(),
  stepMedicalAndEvacuationSCTIData: makeSelectMedicalAndEvacuationSCTIStep(),
  stepBaggageAndPersonalItemsSCTIData: makeSelectBaggageAndPersonalItemsSCTIStep(),
  stepChangesToYourJourneySCTIData: makeSelectChangesToYourJourneySCTIStep(),
  stepChangesToYourJourneyData: makeSelectChangesToYourJourneyStep(),
  stepBaggageAndPersonalItemsData: makeSelectStepBaggageAndPersonalItems(),
  stepMedicalExpenseCFData: makeSelectMedicalExpenseCFStep(),
  stepBaggageAndPersonalItemsStarrData: makeSelectStepBaggageAndPersonalItemsStarr(),
  stepOtherStarrData: makeSelectStepOtherStarr(),
  stepCollisionDamageStarrData: makeSelectCollisionDamageStarrStep(),
  stepCollisionDamageData: makeSelectCollisionDamageStep(),
  stepCashBankCardsTravelDocumentsAndPassportsData: makeSelectCashBankCardsTravelDocumentsAndPassportsStep(),
  stepMedicalExpensesTugoData: makeSelectMedicalExpensesTugoStep(),
  stepOtherTugoData: makeSelectStepOtherTugo(),
  // stepMedicalExpenseCFData: makeSelectMedicalExpenseCFStep(),
  stepBaseVictorsMedicalTugoData: makeSelectBaseVictorsMedicalTugo(),
  stepStudentMedicalBenefitsTugoData: makeSelectStudentMedicalBenefitsTugo(),
  stepTripCancellationTugoData: makeSelectStepTripCancellationTugo(),
  stepTripCancellationTravellerTugoData: makeSelectStepTripCancellationTravellerTugo(),
  stepTripInterruptionTugoData: makeSelectTripInterruptionTugo(),
  stepStandardVTCMedicalBenefitsTugoData: makeSelectStandardVTCMedicalBenefitsTugo(),
  stepTravellerMedicalBenefitsTugoData: makeSelectTravellerMedicalBenefitsTugo(),
  stepOptimumMedicalBenefitsTugoData: makeSelectOptimumMedicalBenefitsTugo(),
  stepADAndDBenefitsTugoData: makeSelectADAndDBenefitsTugo(),
  stepOtherInsuranceCoverageTugoData: makeSelectStepOtherInsuranceCoverageTugo(),
  stepBaggageAndPersonalItemsTravellerTugoData: makeSelectBaggageAndPersonalItemsTravellerTugo(),
  stepRentalCarProtectionTravellerTugoData: makeSelectRentalCarProtectionTravellerTugo(),
  stepMedicalExpensesData: makeSelectStepMedicalExpenses(),
  claimTypesInit: makeSelectInitClaimTypeList(),
  jsonVersion: makeSelectJSONVersion(),
  showRequiredDocument: makeSelectShowRequiredDocument(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  policyPlanIds: makeSelectPolicyPlanIds(),
  showZurichUHC: makeSelectShowZurichUHC(),
  errors: makeSelectStepSupportingDocumentsErrors(),
  currentStep: makeSelectCurrentStep(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFileUpload: (files, benefitCode, documentDescription) => dispatch(uploadFile(files, benefitCode, documentDescription)),
  onRequireDocFileUpload: (files, uploadRequest) => dispatch(uploadRequireDocFile(files, uploadRequest)),
  onFileRemove: (file) => dispatch(removeFile(file)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => {
    dispatch(resetFormData());
  },
  onRunRequiredDocValidation: (attachmentIds, requiredDocumentId, claimTypeId) =>
    dispatch(runRequiredDocValidation(attachmentIds, requiredDocumentId, claimTypeId)),
  onCancelRequiredDocValidation: (requiredDocumentId, claimTypeId) =>
    dispatch(cancelRequiredDocValidation(requiredDocumentId, claimTypeId)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepSupportingDocuments', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl
)(StepSupportingDocuments);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/index.js